type FileExtBadgeIconProps = {
  className?: string;
  /** 배지에 찍는 글자 — 확장자를 대문자로 올린다(PDF / DOCX / XLSX). */
  label: string;
  /** 배지 배경색 — 파일 계열별로 다르다. */
  color: string;
  height?: number;
};

/** 글자 수에 맞춘 배지 폭(높이 24 기준). 기존 PdfBadgeIcon(36, "PDF") 과 같은 눈높이. */
const badgeWidth = (label: string) => Math.round(label.length * 7 + 15);

/**
 * 파일 확장자 배지 — 색은 계열, 글자는 확장자.
 * 확장자가 늘어도 이 컴포넌트는 그대로고 file-type-indicator 의 표만 늘어난다.
 */
const FileExtBadgeIcon = ({
  className,
  label,
  color,
  height = 24,
}: FileExtBadgeIconProps) => {
  const base = badgeWidth(label);
  const scale = height / 24;

  return (
    <svg
      width={Math.round(base * scale)}
      height={height}
      viewBox={`0 0 ${base} 24`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect width={base} height="24" rx="4" fill={color} />
      <text
        x={base / 2}
        y="16.5"
        textAnchor="middle"
        fontFamily="Pretendard, Helvetica, Arial, sans-serif"
        fontSize="11"
        fontWeight="700"
        fill="white"
      >
        {label}
      </text>
    </svg>
  );
};

export default FileExtBadgeIcon;
